export default __webpack_public_path__ + "static/media/card1.a4e566b1.png";